// src/discover/discoverApi.ts
import { apiClient } from "@maat/api-base";
var discoverApi = {
  /**
   * `GET /discover/listings` — the paged per-kind browse, backend-filtered and
   * backend-paged. `date` narrows to a scheduled, bookable, future session whose
   * LOCAL date matches, so it is a DIFFERENT read from an undated one rather than a
   * filter over it.
   */
  listListings: async (params) => {
    return apiClient.get("/main/api/discover/listings", { params });
  },
  /**
   * `GET /discover/facets` — "Photography · 16 available", per category. Counts
   * describe the WHOLE set for the kind and the city and are never recomputed as a
   * category is selected: a chip row that renumbered on selection would tell a guest
   * their filter changed the world.
   */
  getFacets: async (params) => {
    return apiClient.get("/main/api/discover/facets", { params });
  },
  /**
   * `GET /discover/happening-today` — the rail, ordered by start time. A QUERY, not
   * curated content: `next_slot_starts_at` today. Every row has a session on the
   * calendar, so the card's time chip can never be empty.
   */
  getHappeningToday: async (params = {}) => {
    return apiClient.get("/main/api/discover/happening-today", { params });
  },
  /**
   * `GET /discover/similar/:listingId` — "more like this", same kind, category
   * first then proximity. 404 for an unknown, inactive or sandbox source.
   */
  getSimilar: async (listingId) => {
    return apiClient.get(`/main/api/discover/similar/${listingId}`);
  }
};

export {
  discoverApi
};
